import { MARQUEE_ITEMS } from "../data/catalogue";
import { Swirl } from "./Shared";

const Strip = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {MARQUEE_ITEMS.map((item, i) => {
      const isDevanagari = /[\u0900-\u097F]/.test(item);
      return (
        <span key={`${item}-${i}`} className="flex items-center">
          <span
            className={`whitespace-nowrap px-6 sm:px-10 text-2xl sm:text-4xl ${
              isDevanagari
                ? "font-display text-coral"
                : i % 2 === 0
                  ? "font-serif italic text-ink"
                  : "font-serif text-ink"
            }`}
          >
            {item}
          </span>
          <Swirl className="h-5 w-5 shrink-0" />
        </span>
      );
    })}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="marquee-band"
      className="marquee relative overflow-hidden border-y border-sand bg-parchment/60 py-6 sm:py-8"
    >
      <div className="marquee-track">
        <Strip />
        <Strip ariaHidden />
      </div>
    </div>
  );
}
